import Divider from "@mui/material/Divider";
import type { PaperProps } from "@mui/material/Paper";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import type { FC } from "react";

import { BrowseSection } from "~/feature/search/components/BrowseSection";
import { InsightsSummaryRow } from "~/feature/search/components/InsightsSummaryRow";
import { RecentSection } from "~/feature/search/components/RecentSection";
import { SearchEntityBlock } from "~/feature/search/components/SearchEntityBlock/SearchEntityBlock";
import { TrendingSection } from "~/feature/search/components/TrendingSection";
import type {
  ISearchEntity,
  ISearchInsightsSummary,
} from "~/feature/search/type";

import * as Styled from "./SearchPaper.styles";

interface ISearchPaperProps extends PaperProps {
  isResult: boolean;
  isTyping: boolean;
  entity?: ISearchEntity | null;
  insights?: ISearchInsightsSummary | null;
  onInsightsSelect?: (query: string) => void;
  onNavigate?: () => void;
  recentSearches?: string[];
  onRemoveRecent?: (query: string) => void;
}

export const SearchPaper: FC<ISearchPaperProps> = ({
  children,
  isResult,
  isTyping,
  entity,
  insights,
  onInsightsSelect,
  onNavigate,
  recentSearches = [],
  onRemoveRecent,
  ...paperProps
}) => {
  return (
    <Paper {...paperProps}>
      {!isTyping && (
        <>
          <BrowseSection onNavigate={onNavigate} />
          <Divider />
          {recentSearches.length > 0 && (
            <>
              <RecentSection
                items={recentSearches}
                onRemove={onRemoveRecent ?? (() => {})}
                onNavigate={onNavigate}
              />
              <Divider />
            </>
          )}
          <TrendingSection onNavigate={onNavigate} />
          <Divider />
        </>
      )}

      {isTyping && entity && (
        <>
          <Styled.EntityWrapper>
            <SearchEntityBlock entity={entity} onNavigate={onNavigate} />
          </Styled.EntityWrapper>
          <Divider />
        </>
      )}

      {children}

      {insights && (
        <>
          <Divider />
          <InsightsSummaryRow {...insights} onSelect={onInsightsSelect} />
        </>
      )}

      {isResult && (
        <>
          <Divider />
          <Styled.Footer>
            <Typography variant="caption" color="gray">
              Press ↵ to view all results including resolved
            </Typography>
            <Typography variant="caption" color="gray">
              <strong>esc</strong> to close
            </Typography>
          </Styled.Footer>
        </>
      )}
    </Paper>
  );
};
